import { AxiosInstance } from 'axios'
import { IUserCarrier } from '~/carrier/user/IUserCarrier'
import { Carrier } from '~/carrier/Carrier'

export class UserCarrier extends Carrier implements IUserCarrier {
  constructor(api: AxiosInstance, private readonly jsonApi: AxiosInstance) {
    super(api, 'user')
  }

  public search(query: string) {
    return this.api.get('users', { params: { q: query } })
  }

  public get() {
    return this.jsonApi.get(this.path)
  }

  public put(data: object) {
    return this.jsonApi.put(this.path, data)
  }

  public delete() {
    return this.jsonApi.delete(this.path)
  }

  public logout(payload: object) {
    return this.jsonApi.post('log_out', payload)
  }
}
